// Source: app/scripts/services/auth.js
Auction.factory('UserService', function ($resource) {
  return $resource('/data/rest/user/:action', {}, {
    authenticate: {
      method: 'POST',
      params: {
        'action': 'authenticate'
      },
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    },
    passwordRenew: {
      method: 'POST',
      url: '/data/rest/user/renew_password'
    },
    getLog: {
      method: 'GET',
      url: '/data/rest/users/log',
      isArray: true
    },
    getMfaLog: {
      method: 'GET',
      url: '/data/rest/users/log/mfa',
      isArray: true
    },
    remindUsername: {
      method: 'POST',
      url: '/data/rest/user/remind_username'
    },
    verifyMfa: {
      method: 'POST',
      params: {
        'action': 'verify-mfa'
      },
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    },
    getMfaStatus: {
      method: 'GET',
      url: '/data/rest/user/mfa/status'
    },
    setupMfa: {
      method: 'POST',
      url: '/data/rest/user/mfa/setup'
    },
    confirmMfa: {
      method: 'POST',
      url: '/data/rest/user/mfa/confirm'
    },
    disableMfa: {
      method: 'POST',
      url: '/data/rest/user/mfa/disable'
    },
    regenerateBackupCodes: {
      method: 'POST',
      url: '/data/rest/user/mfa/regenerate-backup-codes'
    },
    resetUserMfa: {
      method: 'POST',
      url: '/data/rest/users/mfa/reset'
    }

  });
});

Auction.factory('User', ['$resource', function ($resource) {
  return $resource('/data/rest/users/:id', {});
}]);

Auction.factory('Auth', [
  '$rootScope',
  '$cookieStore',
  '$cookies',
  '$location',
  'UserService',
  'ProductSubcategories',
  '$translate',
  '$window',
  '$timeout',
  function ($rootScope, $cookieStore, $cookies, $location, UserService, ProductSubcategories, $translate, $window, $timeout) {
    var callbacks = [];

    return {
      getUser: function (callback) {
        if (!$rootScope.loginAction) {
          $rootScope.authToken = $cookieStore.get('token');
          delete $rootScope.loginAction;
        }
        if ($rootScope.authToken !== undefined) {
          UserService.get(function (u) {
            $rootScope.user = u;
            if (callback && typeof callback === 'function') {
              callback(u);
              for (var i = 0; i < callbacks.length; i++) {
                callbacks[i](u);
              }
            }
          });
        } else {
          if ($location.path() != "/login") {
            $rootScope.returnPath = $location.path();
          }
          $location.path("/login");
        }
      },
      registerCallback: function (callback) {
        callbacks.push(callback);
      },
      authenticate: function (callback) {
        UserService.get(function (u) {
          console.log('na pravilno mesto');
          console.log(u);

          $translate.use(u.lang);
          $rootScope.lang = u.lang;

          moment.lang(u.lang);
          $timeout(function refresh() {
            $window.location.reload();
          }, 500)

        });
      },
      checkValidPage: function (user) {
        var path = $location.path();
        if (path === "/") return true;
        for (var i = 0; i < user.rolePages.length; ++i) {
          var url = user.rolePages[i].url;
          if (path.indexOf(url) == 0) {
            $rootScope.activePage = user.rolePages[i];
            return true;
          }
        }
        for (var i = 0; i < user.userPages.length; ++i) {
          var url = user.userPages[i].url;
          if (path.indexOf(url) == 0) {
            $rootScope.activePage = user.userPages[i];
            return true;
          }
        }
        return false;
      },
      logout: function () {
        delete $rootScope.user;
        delete $rootScope.authToken;
        $cookies['token'] = null;
        delete $cookies['token'];
        $location.path("/login");
        var delete_cookie = function (name) {
          document.cookie = name + '=; Path=/web-portal-test; expires=Thu, 01 Jan 1970 00:00:01 GMT;';
        };
        delete_cookie('token');

        $rootScope.navigation = null;
        $rootScope.navigation = ProductSubcategories.categoryNavigation();
      },
      getToken: function () {
        return authToken;
      }
    };
  }
]);

Auction.factory('Nav', ['$rootScope', '$location', 'Page', '$cookieStore', function ($rootScope, $location, Page, $cookieStore) {
  var callbacks = [];
  return {
    fetch: function (service, adapter) {
      if (typeof service === 'function') {
        service(function (data) {
          if (adapter) {
            $rootScope.navigation = adapter(data);
          } else {
            $rootScope.navigation = data;
          }
          if(!$rootScope.system){
            var systemToken = $cookieStore.get('systemToken');
            if(systemToken){
              $rootScope.system = systemToken;
            }else{
              $rootScope.system = 'GENERAL';
            }
            $rootScope.showOption = 0;
          }
          Page.navigationBySystem({system : $rootScope.system} ,  function (data) {
            angular.forEach(data.pages, function (p) {
                p.hidden = true;
                $rootScope.navigation.pages.push(p);

            });
            angular.forEach(callbacks, function (fn) {
              fn($rootScope.navigation);
            });
          });

        });
      } else {
        if(!$rootScope.system){
          var systemToken = $cookieStore.get('systemToken');
          if(systemToken){
            $rootScope.system = systemToken;
          }else{
            $rootScope.system = 'GENERAL';
          }
        }
        Page.navigationBySystem({system : $rootScope.system}, function (data) {
          $rootScope.navigation = data;
          angular.forEach(callbacks, function (fn) {
            fn(data);
          });
        });
      }
    },
    registerCallback: function (fn) {
      callbacks.push(fn);
    },
    newFetch: function (system) {

        Page.navigationBySystem({system : system}, function (data) {
          $rootScope.navigation = data;
          angular.forEach(callbacks, function (fn) {
            fn(data);
          });
        });

    },
    registerCallback: function (fn) {
      callbacks.push(fn);
    },
    current: function () {
      var path = $location.path(),
        nav = $rootScope.navigation, url;
      if (!nav || !nav.pages) return null;
      for (var i = 0; i < nav.pages.length; ++i) {
        url = nav.pages[i].url;
        if (path.indexOf(url) == 0) {
          return nav.pages[i];
        }
      }
      return null;
    },
    hasAccess: function () {
      var path = $location.path(),
        nav = $rootScope.navigation, url;
      if (path === "/" || path === "/login" || path === "/login-mfa" ||
          path === "/access_denied" || path === "/404" ||
          path.indexOf("/forgotten") === 0) {
        return true;
      }
      if (!nav || !nav.pages) return true;
      for (var i = 0; i < nav.pages.length; ++i) {
        url = nav.pages[i].url;
        if (path.indexOf(url) == 0) {
          return true;
        }
      }
      return false;
    }
  }
}]);

Auction.factory('PageGroup', ['$resource', function ($resource) {
  return $resource('/data/rest/page_groups/:id', {}, {
    'getPages': {
      method: 'GET',
      isArray: true,
      url: "/data/rest/page_groups/pages/by_group/:id"
    },
    'getAllPages': {
      method: 'GET',
      isArray: true,
      url: "/data/rest/page_groups/pages"
    },
    'addPage': {
      method: 'POST',
      url: '/data/rest/page_groups/pages/add'
    },
    'getPageById': {
      method: 'GET',
      url: "/data/rest/page_groups/pages/:id"
    },
    'deletePage': {
      method: 'DELETE',
      url: "/data/rest/page_groups/pages/:id"
    }
  });
}]);


Auction.factory('Page', ['$resource', function ($resource) {
  return $resource('/data/rest/pages/:id', {}, {
    'assign': {
      method: 'POST',
      url: '/data/rest/pages/assign'
    },
    'navigation': {
      method: 'GET',
      url: '/data/rest/pages/navigation'
    },
    'findAssigned': {
      method: 'GET',
      isArray: true,
      url: '/data/rest/pages/:id/assigned_roles'
    },
    'findPageContent': {
      method: 'GET',
      url: '/data/rest/pages/content'
    },
    'navigationBySystem': {
      method: 'GET',
      url: '/data/rest/pages/navigation/system'
    }
  });
}]);
